module.exports = __webpack_public_path__ + "static/doctolib-thumbnail-5d57b4315db4f5a218703dc47495c02f.gif";